import { create } from 'zustand';

const SIZES = [22, 30, 45] as const;
export type ChatPanelSize = (typeof SIZES)[number];

interface ChatPanelState {
  isOpen: boolean;
  size: ChatPanelSize;
  toggle: () => void;
  setOpen: (v: boolean) => void;
  expand: () => void;
  shrink: () => void;
  canExpand: () => boolean;
  canShrink: () => boolean;
}

export const useChatPanel = create<ChatPanelState>((set, get) => ({
  isOpen: true,
  size: 30,
  toggle: () => set((s) => ({ isOpen: !s.isOpen })),
  setOpen: (v) => set({ isOpen: v }),
  expand: () =>
    set((s) => {
      const i = SIZES.indexOf(s.size);
      const next = SIZES[Math.min(i + 1, SIZES.length - 1)];
      return { size: next };
    }),
  shrink: () =>
    set((s) => {
      const i = SIZES.indexOf(s.size);
      const next = SIZES[Math.max(i - 1, 0)];
      return { size: next };
    }),
  canExpand: () => get().size !== SIZES[SIZES.length - 1],
  canShrink: () => get().size !== SIZES[0],
}));
